import React from 'react'
import { findDOMNode } from 'react-dom'
import { withRouter } from 'react-router-dom'
import Lottery from 'lottery-turntable'
// import { Modal, Icon } from 'antd-mobile-v2'
import { Dialog, Modal } from 'antd-mobile'
import { postMessage } from '../../../utils'
import TurntablePointer from '../../../assets/img/turntable-pointer.png'
import TurntableBottom from '../../../assets/xiniu/turntable/turntable-bottom.png'
// import TempImg from '../../assets/img/turntable-pointer.png'

// let values = []
// for (let i = 0; i < 6; i++) {
//   values.push({
//     id: i,
//     name: `title ${i}`,
//     img: {
//       width: 100,
//       height: 50,
//       src: imgSrc
//     },
//     color: '#FF302D',
//     bg: (i % 2 === 0) ? '#FFF68B' : '#FFD428'
//   })
// }

const TURNTABLE_SIZE_S = 260
const TURNTABLE_SIZE_M = 280
const TURNTABLE_SIZE_L = 480
const BOUND_M = 320
const BOUND_L = 640

@withRouter
class TurntableMain extends React.PureComponent {
  constructor (props) {
    super(props)
    // 根据屏幕宽度处理turntable的大小
    if (window.innerWidth > BOUND_L) {
      this.state.turntableSize = TURNTABLE_SIZE_L
    } else if (window.innerWidth > BOUND_M) {
      this.state.turntableSize = TURNTABLE_SIZE_M
    }
  }

  state = {
    turntableSize: TURNTABLE_SIZE_S,
    lotteryConfig: {
      consumerIntegral: 0,
      count: 0,
      integral: 0
    },
    // 奖品数据转成根据ID为key的Map数据
    prizeMap: {},
    // 抽奖后中奖奖品数据
    lotteryPrize: {},
    modalVisible: false
  }

  turntable
  losingLotteryId = ''
  loading = false

  componentDidMount () {
    // window.addEventListener('resize', this.handleTurntableResize)
    window.toast.show('载入中...')
    this.getPrizeList().then(this.handlePrizeList)
      .catch(e => console.error(e))
      .finally(() => {
        window.toast.hide()
        if (!sessionStorage.getItem('token')) this.alertLoginModal()
      })
    this.getLotteryConfig()
  }

  // imgUrl是轮盘里的图片,giftImgUrl是抽到后弹窗的图片
  render () {
    const { turntableSize, lotteryConfig, modalVisible, prizeMap, lotteryPrize } = this.state
    let modalUrl = prizeMap[lotteryPrize['id']] ? prizeMap[lotteryPrize['id']]['giftImgUrl'] : ''

    return <div>
      <div className={'turntable__padding'}>&emsp;</div>
      <div className={'turntable__info-top'}>
        今日剩余抽奖次数： {lotteryConfig.count}<br/>
        <span onClick={this.goToLog}>领取记录 <i className={'icon-font icon-arrow-right-bold'}/></span>
      </div>
      <div className={'turntable__main turntable__main--xiniu'} style={{ height: turntableSize, width: turntableSize }}
           ref={'turntable'}>
        <img src={TurntablePointer} alt="" className={'turntable__pointer'} onClick={this.postLottery}/>
      </div>
      <img src={TurntableBottom} alt="" className={'turntable__bottom'}/>
      <div className="turntable__info-middle turntable__info-middle--xiniu">
        每次抽奖消耗 <span>{lotteryConfig.consumerIntegral}</span> 积分<br/>
        您的剩余积分： <span>{lotteryConfig.integral}</span>
      </div>

      <Modal
        className={'turntable__modal'}
        bodyClassName={'!bg-transparent'}
        visible={modalVisible}
        content={<div className="flex flex-col justify-center items-center">
          {
            modalUrl
              ? <img src={modalUrl} className={'w-full h-auto'} alt=""
                     onClick={this.clickModal}/>
              : <div className={'turntable__modal__text'}>
                抽奖程序出错，请将此界面截图至客服。
                <br/>
                {JSON.stringify(lotteryPrize)}
                <br/>
                {JSON.stringify(prizeMap[lotteryPrize['id']])}
              </div>
          }
          <div className={'turntable__modal__icon'} onClick={this.closeModal}>
            <i className={'icon-font icon-close'}/>
          </div>
        </div>}
      />


      {/*<Modal*/}
      {/*className={'turntable__modal'}*/}
      {/*visible={true}>*/}
      {/*<img src={TempImg} className={'turntable__modal__img'} alt=''*/}
      {/*onClick={this.clickModal} />*/}
      {/*<div className={'turntable__modal__icon'} onClick={this.closeModal}>*/}
      {/*<FontAwesomeIcon icon={'times'} />*/}
      {/*</div>*/}
      {/*</Modal>*/}
    </div>
  }

  // request
  getLotteryConfig = () => {
    let config = { url: window.API.Turntable.getLotteryConfig }
    return window.axios.request(config)
      .then(this.handleLotteryConfig)
      .catch(e => console.error(e))
  }
  getPrizeList = () => {
    let config = { url: window.API.Turntable.getPrizeList }
    return window.axios.request(config)
  }
  postLottery = () => {
    // 判断是否登陆
    if (!sessionStorage.getItem('token')) {
      this.alertLoginModal()
      return
    } else if (this.loading) return
    window.toast.show('请求中...')
    let config = {
      method: 'post',
      url: window.API.Turntable.postLottery
    }
    window.axios.request(config)
      .then(res => {
        let lotteryPrize = res
        if (res['giftType'] === 3) {
          lotteryPrize.id = this.losingLotteryId
        }
        this.turntable.goto(lotteryPrize['id'], () => {
          this.loading = false
          this.setState({
            lotteryPrize: res,
            modalVisible: true
          })
          this.getLotteryConfig()
        })
      })
      .catch(e => {
        let msg = e.message
        if (msg.match('参与抽奖次数已满')) msg = '今日抽奖次数已用完'
        // Modal.alert('抱歉', msg, [{ text: '确定' }])
        Dialog.alert({
          title: '抱歉',
          content: msg
        }).then()
        console.error(e)
      })
      .finally(() => window.toast.hide())
  }
  // handler
  handleLotteryConfig = (res) => {
    this.setState({ lotteryConfig: res })
  }
  handlePrizeList = (res) => {
    if (!Array.isArray(res) || res.length <= 0) throw Error('奖品列表为[]')
    let prizeMap = {}
    let values = res.map((item, key) => {
      if (item['giftType'] === 3) this.losingLotteryId = item['id']
      prizeMap[item['id']] = item
      return {
        id: item['id'],
        name: item['giftDesc'],
        img: {
          width: 60,
          height: 50,
          src: item['imgUrl']
        },
        color: '#FF302D',
        bg: (key % 2 === 0) ? '#FFF68B' : '#FFD428'
      }
    })
    this.setState({
      prizeMap
    })
    this.turntable = new Lottery({
      type: 'transition',
      size: this.state.turntableSize,
      textSpace: 4,
      imgSpace: 40,
      values
    })
    this.turntable.draw(findDOMNode(this.refs['turntable']))
  }
  // 得想办法重绘turntable
  // handleTurntableResize = () => {
  //   let turntableSize = TURNTABLE_SIZE_S
  //   if (window.innerWidth > BOUND_L) {
  //     turntableSize = TURNTABLE_SIZE_L
  //   } else if (window.innerWidth > BOUND_M) {
  //     turntableSize = TURNTABLE_SIZE_M
  //   }
  //   if (turntableSize !== this.state.turntableSize) {
  //     this.setState({ turntableSize })
  //   }
  // }
  clickModal = () => {
    const { giftType, extMap } = this.state.lotteryPrize
    this.setState({ modalVisible: false }, () => {
      switch (giftType) {
        case 1:
          // 积分奖品，转跳至积分商城
          this.props.history.push(window.PATH.INTEGRAL)
          break
        case 2:
          // 券奖品，转跳至对应下单页
          postMessage({
            type: window.POST_TYPE.BUY,
            data: this.state.lotteryPrize
          })
          break
        case 4:
          // 零售券奖品，若有id则对应至对应详情页，无则商城首页
          let { productId } = extMap
          if (productId) {
            this.props.history.push(`${window.PATH.MALL_PRODUCT_DETAILS}/${productId}`)
          } else {
            this.props.history.push(window.PATH.MALL_HOME)
          }
          break
        default:
          return
      }
    })
  }
  closeModal = () => {
    this.setState({
      modalVisible: false
    })
  }
  goToLog = () => {
    if (!sessionStorage.getItem('token')) {
      this.alertLoginModal()
      return
    }
    this.props.history.push(window.PATH.LOTTERY_LOG)
  }
  alertLoginModal = () => {
    // Modal.alert('未登陆', '参加抽奖请先登陆账号', [
    //   { text: '取消' },
    //   {
    //     text: '登陆', onPress: () => {postMessage(window.POST_TYPE.LOGIN_REQUEST)}
    //   }
    // ])
    Dialog.confirm({
      title: '未登陆',
      content: '参加抽奖请先登陆账号',
      confirmText: '登录',
      onConfirm: () => {
        postMessage(window.POST_TYPE.LOGIN_REQUEST)
      }
    })
  }

}

export default TurntableMain
